module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "Graphics",
		"url": "/category/graphics",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=graphics",
				"isTop": true
			},
			{
				"name": "3D Renders",
				"url": "/category/graphics/3d-renders"
			},
			{
				"name": "Backgrounds",
				"url": "/category/graphics/backgrounds"
			},
			{
				"name": "Decorative",
				"url": "/category/graphics/decorative"
			},
			{
				"name": "Hero Images",
				"url": "/category/graphics/hero-images"
			},
			{
				"name": "Illustrations",
				"url": "/category/graphics/illustrations"
			},
			{
				"name": "Photo Templates",
				"url": "/category/graphics/photo-templates"
			},
			{
				"name": "Product Mock-Ups",
				"url": "/category/graphics/product-mock-ups"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/graphics/miscellaneous"
			}
		]
	},
	{
		"name": "Print",
		"url": "/category/print-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=print-templates",
				"isTop": true
			},
			{
				"name": "Brochures",
				"url": "/category/print-templates/brochures"
			},
			{
				"name": "Business Cards",
				"url": "/category/print-templates/business-cards"
			},
			{
				"name": "Cards & Invites",
				"url": "/category/print-templates/cards-invites"
			},
			{
				"name": "CD & DVD Artwork",
				"url": "/category/print-templates/cd-dvd-artwork"
			},
			{
				"name": "ePublishing",
				"url": "/category/epublishing"
			},
			{
				"name": "Flyers",
				"url": "/category/print-templates/flyers"
			},
			{
				"name": "Food Menus",
				"url": "/category/print-templates/food-menus"
			},
			{
				"name": "Magazines",
				"url": "/category/print-templates/magazines"
			},
			{
				"name": "Newsletters",
				"url": "/category/print-templates/newsletters"
			},
			{
				"name": "Packaging",
				"url": "/category/print-templates/packaging"
			},
			{
				"name": "Photo Albums",
				"url": "/category/print-templates/photo-albums"
			},
			{
				"name": "Signage",
				"url": "/category/print-templates/signage"
			},
			{
				"name": "Stationery",
				"url": "/category/print-templates/stationery"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/print-templates/miscellaneous"
			}
		]
	},
	{
		"name": "Web Elements",
		"url": "/category/web-elements",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=web-elements",
				"isTop": true
			},
			{
				"name": "404 Pages",
				"url": "/category/web-elements/4-4-pages"
			},
			{
				"name": "Badges & Stickers",
				"url": "/category/web-elements/badges-stickers"
			},
			{
				"name": "Banners & Ads",
				"url": "/category/web-elements/banners-ads"
			},
			{
				"name": "Buttons",
				"url": "/category/web-elements/buttons"
			},
			{
				"name": "E-newsletters",
				"url": "/category/web-elements/e-newsletters"
			},
			{
				"name": "Forms",
				"url": "/category/web-elements/forms"
			},
			{
				"name": "Navigation Bars",
				"url": "/category/web-elements/navigation-bars"
			},
			{
				"name": "Sliders & Features",
				"url": "/category/web-elements/sliders-features"
			},
			{
				"name": "Social Media",
				"url": "/category/web-elements/social-media"
			},
			{
				"name": "Tables",
				"url": "/category/web-elements/tables"
			},
			{
				"name": "User Interfaces",
				"url": "/category/web-elements/user-interfaces"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/web-elements/miscellaneous"
			}
		]
	},
	{
		"name": "Add-ons",
		"url": "/category/add-ons",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=add-ons",
				"isTop": true
			},
			{
				"name": "Aperture Presets",
				"url": "/category/add-ons/aperture-presets"
			},
			{
				"name": "Illustrator",
				"url": "/category/add-ons/illustrator"
			},
			{
				"name": "Lightroom Presets",
				"url": "/category/add-ons/lightroom-presets"
			},
			{
				"name": "Photoshop",
				"url": "/category/add-ons/photoshop"
			},
			{
				"name": "Sketch Plugins",
				"url": "/category/add-ons/sketch-plugins"
			}
		]
	},
	{
		"name": "Vectors",
		"url": "/category/vectors",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=vectors",
				"isTop": true
			},
			{
				"name": "Characters",
				"url": "/category/vectors/characters"
			},
			{
				"name": "Conceptual",
				"url": "/category/vectors/conceptual"
			},
			{
				"name": "Decorative",
				"url": "/category/vectors/decorative"
			},
			{
				"name": "Objects",
				"url": "/category/vectors/objects"
			},
			{
				"name": "Tattoos",
				"url": "/category/vectors/tattoos"
			},
			{
				"name": "Web Elements",
				"url": "/category/vectors/web-elements"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/vectors/miscellaneous"
			}
		]
	},
	{
		"name": "Presentations",
		"url": "/category/presentation-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=presentation-templates",
				"isTop": true
			},
			{
				"name": "Google Slides",
				"url": "/category/presentation-templates/google-slides"
			},
			{
				"name": "Keynote Templates",
				"url": "/category/presentation-templates/keynote-templates"
			},
			{
				"name": "PowerPoint Templates",
				"url": "/category/presentation-templates/powerpoint-templates"
			}
		]
	},
	{
		"name": "Infographics",
		"url": "/category/infographics",
		"children": []
	},
	{
		"name": "Icons",
		"url": "/category/icons",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=icons",
				"isTop": true
			},
			{
				"name": "Abstract",
				"url": "/category/icons/abstract"
			},
			{
				"name": "Business",
				"url": "/category/icons/business"
			},
			{
				"name": "Characters",
				"url": "/category/icons/characters"
			},
			{
				"name": "Media",
				"url": "/category/icons/media"
			},
			{
				"name": "Objects",
				"url": "/category/icons/objects"
			},
			{
				"name": "Seasonal",
				"url": "/category/icons/seasonal"
			},
			{
				"name": "Software",
				"url": "/category/icons/software"
			},
			{
				"name": "Technology",
				"url": "/category/icons/technology"
			},
			{
				"name": "Web",
				"url": "/category/icons/web"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/icons/miscellaneous"
			}
		]
	},
	{
		"name": "Fonts",
		"url": "/category/fonts",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=fonts",
				"isTop": true
			},
			{
				"name": "Cool",
				"url": "/category/fonts/cool"
			},
			{
				"name": "Decorative",
				"url": "/category/fonts/decorative"
			},
			{
				"name": "Ding-bats",
				"url": "/category/fonts/ding-bats"
			},
			{
				"name": "Fancy",
				"url": "/category/fonts/fancy"
			},
			{
				"name": "Graffiti",
				"url": "/category/fonts/graffiti"
			},
			{
				"name": "Handwriting",
				"url": "/category/fonts/handwriting"
			},
			{
				"name": "Sans-Serif",
				"url": "/category/fonts/sans-serif"
			},
			{
				"name": "Script",
				"url": "/category/fonts/script"
			},
			{
				"name": "Serif",
				"url": "/category/fonts/serif"
			}
		]
	},
	{
		"name": "Logos",
		"url": "/category/logo-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=logo-templates",
				"isTop": true
			},
			{
				"name": "Abstract",
				"url": "/category/logo-templates/abstract"
			},
			{
				"name": "Animals",
				"url": "/category/logo-templates/animals"
			},
			{
				"name": "Buildings",
				"url": "/category/logo-templates/buildings"
			},
			{
				"name": "College",
				"url": "/category/logo-templates/college"
			},
			{
				"name": "Company",
				"url": "/category/logo-templates/company"
			},
			{
				"name": "Crests",
				"url": "/category/logo-templates/crests"
			},
			{
				"name": "Food",
				"url": "/category/logo-templates/food"
			},
			{
				"name": "Humans",
				"url": "/category/logo-templates/humans"
			},
			{
				"name": "Letters",
				"url": "/category/logo-templates/letters"
			},
			{
				"name": "Nature",
				"url": "/category/logo-templates/nature"
			},
			{
				"name": "Numbers",
				"url": "/category/logo-templates/numbers"
			},
			{
				"name": "Objects",
				"url": "/category/logo-templates/objects"
			},
			{
				"name": "Restaurant",
				"url": "/category/logo-templates/restaurant"
			},
			{
				"name": "Sports",
				"url": "/category/logo-templates/sports"
			},
			{
				"name": "Symbols",
				"url": "/category/logo-templates/symbols"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "Game Assets",
				"url": "/category/game-assets"
			},
			{
				"name": "Isolated Objects",
				"url": "/category/isolated-objects"
			},
			{
				"name": "T-Shirts",
				"url": "/category/t-shirts"
			},
			{
				"name": "Textures",
				"url": "/category/textures"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/menus/graphicriver.json
// module id = 228
// module chunks = 1 2